// Genererad bildkatalog för affärsområdet Foto.
// Bildbiblioteket är tömt. Lägg endast till bilder med verifierade användningsrättigheter vid återlansering.

export type PhotoCategory = "portratt" | "kampanj" | "studio" | "dronare";

export interface PhotoItem {
  id: string;
  src: string;
  w: number;
  h: number;
  category: PhotoCategory;
  alt: string;
}

/** Empty until new images with verified rights are supplied. */
export const photos: PhotoItem[] = [];

export const CATEGORY_LABELS: Record<PhotoCategory, string> = {
  portratt: "Företagsporträtt",
  kampanj: "Kampanj & varumärke",
  studio: "Studio",
  dronare: "Drönarfoto",
};

export function photosBy(category: PhotoCategory): PhotoItem[] {
  return photos.filter((p) => p.category === category);
}

/** Galleribilder för fotoavdelningen. */
export const galleryPhotos: PhotoItem[] = photos;

/**
 * Deterministiskt vald omslagsbild per sid-slug. Ger varje foto-SEO-sida en
 * egen hero-bild utan att bilderna hoppar mellan renderingar.
 */
export function coverPhotoFor(key: string, category?: PhotoCategory): PhotoItem {
  const pool = category ? photosBy(category) : galleryPhotos;
  const list = pool.length > 0 ? pool : galleryPhotos;
  let h = 0;
  for (let i = 0; i < key.length; i++) h = (h * 31 + key.charCodeAt(i)) >>> 0;
  return list[h % list.length] ?? { id: "empty", src: "", w: 1, h: 1, category: category ?? "portratt", alt: "" };
}
